import React, { useEffect, useState } from 'react';
import { fetchFeedbackSummary } from '../utils/platformFeedback';
import PlatformExperiencesModal from './PlatformExperiencesModal';

const PlatformExperienceSummary = ({ className = '' }) => {
  const [summary, setSummary] = useState(null);
  const [experiencesOpen, setExperiencesOpen] = useState(false);

  useEffect(() => {
    fetchFeedbackSummary().then(setSummary);
  }, []);

  useEffect(() => {
    const onOpen = () => setExperiencesOpen(true);
    window.addEventListener('raheasy:feedback-experiences-open', onOpen);
    return () => window.removeEventListener('raheasy:feedback-experiences-open', onOpen);
  }, []);

  if (!summary || !summary.count) return null;

  const experienceLabel = `${summary.count.toLocaleString()} experience${summary.count === 1 ? '' : 's'}`;

  return (
    <>
      <p className={`platform-experience-summary ${className}`.trim()}>
        Shoppers rate Raheasy{' '}
        <span className="platform-experience-summary-stats">
          <strong>{summary.average}/5</strong>{' '}
          (
          <button
            type="button"
            className="platform-experience-summary-link"
            onClick={() => setExperiencesOpen(true)}
            aria-label={`Read ${experienceLabel}`}
          >
            {experienceLabel}
          </button>
          )
        </span>
      </p>
      <PlatformExperiencesModal
        open={experiencesOpen}
        onClose={() => setExperiencesOpen(false)}
      />
    </>
  );
};

export default PlatformExperienceSummary;
